export enum CreateAnalysisType {
  problem = 1,
  risk = 2,
  improvement = 3,
}
